import { get } from 'lodash'
import { differenceInMinutes, differenceInSeconds } from 'date-fns'

export default {
	now: (state) => {
		return state.now
	},

	valueAtPath: (state) => (path) => {
		return get(state, path)
	},

	id: (state) => {
		if (!state.user) return null
		return state.user.id
	},

	user: (state) => {
		if (!state.user.id) return null
		return state.user
	},

	hasRole: (state) => (role) => {
		if (state.user.roles.includes(role)) return true
	},

	hasRoles: (state) => (roles, all) => {
		let intersect = intersection(state.user.roles, roles)
		if (all) {
			if (intersect.length === roles.length) return true
		} else {
			if (intersect.length > 0) return true
		}
		return
	},

	itemById: (state) => (payload) => {
		if (!state[payload.path]) return
		if (!Array.isArray(state[payload.path])) return
		let prop = payload.prop || 'id'
		return state[payload.path].find((item) => item[prop] === payload.id)
	},

	loaded: (state) => {
		return state.loaded
	},

	tickets: (state) => {
		return state.tickets
	},

	chats: (state) => {
		return state.chats
	},

	users: (state) => {
		return state.users
	},

	pets: (state) => {
		return state.pets
	},

	admins: (state) => {
		return state.admins
	},

	articles: (state) => {
		return state.articles
	},

	categories: (state) => {
		return state.categories
	},

	stories: (state) => {
		return state.stories
	},

	consultations: (state) => {
		return state.consultations
	},

	calls: (state) => {
		return state.calls
	},

	typingUsers: (state) => {
		return state.typingUsers
	},
}
